import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { fdpQueryKeys } from '@teetsh/app/src/queries/fdp/useFicheDePrep';
import { SEQUENCES_LIST_KEY } from '@teetsh/app/src/queries/sequences/useSequencesFolders';
import { SEQUENCE_KEY } from '@teetsh/app/src/queries/sequences/useSequence';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

export function useUpdateSequenceOfFicheDePrep() {
  const { notifyError } = useNotification();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['sequence']);

  const { mutateAsync } = useMutation({
    mutationFn: ({
      srcSequenceId,
      destSequenceId,
      ficheDePrepId,
    }: {
      srcSequenceId: string;
      destSequenceId: string;
      ficheDePrepId: string;
    }) =>
      request(
        `/sequences/${srcSequenceId}/fiches-de-prep/${ficheDePrepId}/update-sequence`,
        {
          method: 'PATCH',
          body: {
            sequenceId: destSequenceId,
          },
        },
      ),
    onMutate: () => {
      const shouldUpdateTree = true;
      return shouldUpdateTree;
    },
    onError: (_, { srcSequenceId, ficheDePrepId }) => {
      notifyError({
        title: t('sequence:messages.seance.updateError'),
      });
      queryClient.invalidateQueries({
        queryKey: fdpQueryKeys.detail(srcSequenceId, ficheDePrepId),
      });
    },
    onSuccess: (
      _,
      { destSequenceId, srcSequenceId, ficheDePrepId },
      context,
    ) => {
      if (context) {
        queryClient.invalidateQueries({
          queryKey: [SEQUENCES_LIST_KEY],
        });
        queryClient.invalidateQueries({
          queryKey: fdpQueryKeys.detail(srcSequenceId, ficheDePrepId),
        });
        queryClient.invalidateQueries({
          queryKey: [SEQUENCE_KEY, destSequenceId],
        });
        queryClient.invalidateQueries({
          queryKey: [SEQUENCE_KEY, srcSequenceId],
        });
      }
    },
  });
  return mutateAsync;
}
